import React from 'react';
import { FormControl, InputLabel, Select, MenuItem, withStyles, OutlinedInput } from '@material-ui/core';

const styles = theme => ({
  formControl: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    marginTop: theme.spacing(3),
  },
});

const ChooseLocationInput = ({ classes, items, value, onChange }) => {
  return (
    <FormControl
      className={classes.formControl}
      fullWidth
    >
      <InputLabel>Valitse toimipiste</InputLabel>
      <Select
        value={value}
        onChange={onChange}   
        input={<OutlinedInput labelWidth={0} />}
      >
        {items.map(i => <MenuItem key={i.key} value={i.key}>{i.description || i.key}</MenuItem>)}
      </Select>
    </FormControl>
  );
};

// @ts-ignore
export default withStyles(styles)(ChooseLocationInput);